<%= form_with(model: age, class: "contents") do |form| %>
  <% if age.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(age.errors.count, "error") %> prohibited this age from being saved:</h2>

      <ul class="list-disc ml-6">
        <% age.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :category %>
    <%= form.text_field :category, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": age.errors[:category].none?, "border-red-400 focus:outline-red-600": age.errors[:category].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :description %>
    <%= form.text_field :description, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": age.errors[:description].none?, "border-red-400 focus:outline-red-600": age.errors[:description].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
